<template>
  <router-view/>
</template>

<script>
export default {
  name: 'router-views'
}
</script>
